import { render, staticRenderFns } from "./item.vue?vue&type=template&id=5a1d4a30"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=5a1d4a30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports